import packageJSON from '@searchspring/snap-toolbox/package.json';
export const { version } = packageJSON;
